import { NavLink } from 'react-router';
import { useI18n } from '../../i18n';
import { useSyndicate } from '../../session';

export function FinancesNav() {
  const { t } = useI18n();
  const base = `${useSyndicate().base}/finances`;
  return (
    <nav className="subnav" aria-label={t.finances.title}>
      <NavLink to={base} end>
        {t.finances.overview}
      </NavLink>
      <NavLink to={`${base}/budget`}>{t.finances.budget}</NavLink>
      <NavLink to={`${base}/bank`}>{t.finances.bank}</NavLink>
      <NavLink to={`${base}/journal`}>{t.finances.journal}</NavLink>
    </nav>
  );
}

/** Parses a dollar amount typed by a person ("1 234,56", "1234.56") into cents. */
export function toCents(input: string): number | null {
  const normalized = input.replace(/[\s $]/g, '').replace(',', '.');
  if (normalized === '' || !/^\d+(\.\d{1,2})?$/.test(normalized)) return null;
  return Math.round(Number(normalized) * 100);
}

export const today = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto' }).format(new Date());
